var render = function render(){var _vm=this,_c=_vm._self._c;return _c('UiTeleport',[_c('div',{staticClass:"private-page-scroller"},[_c('canvas',{ref:"canvas",staticClass:"_dblock"}),_c('div',{staticClass:"private-page-scroller__button",class:{
                'private-page-scroller__button_bottom': !_vm.allowTop,
            },on:{"click":_vm.onClick}},[_c('div',{staticClass:"ico ico-arrow-left ico_color_white ico_size_32"})])])])
}
var staticRenderFns = []

export { render, staticRenderFns }